import { DATA_IMPORT_FLAG } from '@pequity/shared/data-import/constants';
import { isRolloutFlagEnabled } from '@pequity/shared/utils/rollout-flags';
import { type NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { useCompanyStore } from '@/stores/company';

export const redirectToHomeIfNoAccess: NavigationGuard = async () => {
  const { appAccess } = useAuthStore();

  if (!appAccess.nav.people) {
    return { name: 'home' };
  }
  return true;
};

export const redirectToHomeIfNoSettingsAccess: NavigationGuard = async (to) => {
  const { appAccess } = useAuthStore();

  if (!appAccess.people.settings) {
    return { name: 'people-list' };
  }

  if (to.name === 'people-employee-portal-settings' && !appAccess.people.show_employee_portal_settings) {
    return { name: 'people-access-settings' };
  }

  if (to.name === 'people-settings-columns' && (!appAccess.nav.data || isRolloutFlagEnabled(DATA_IMPORT_FLAG))) {
    return { name: 'people-settings' };
  }

  if (to.name === 'people-manager-permissions-settings' && !appAccess.people.show_managers_settings) {
    return { name: 'people-settings' };
  }

  return true;
};

export const redirectToListIfNoSummaryAccess: NavigationGuard = async () => {
  const { appAccess } = useAuthStore();

  if (!appAccess.people.summary.view) {
    return { name: 'people-list' };
  }
  return true;
};

export const refreshCompanySettings: NavigationGuard = async () => {
  await useCompanyStore().fetchCompanies();
  return true;
};

export const redirectToHomeIfNoMyPortalAccess: NavigationGuard = async () => {
  const authStore = useAuthStore();
  const companyStore = useCompanyStore();

  if (
    companyStore.usingEmployeePortal &&
    authStore.profile?.employee_v2_id &&
    (authStore.isUserAdmin || companyStore.nonAdminAccessToEmployeePortal)
  ) {
    return true;
  } else {
    return { name: 'home' };
  }
};
